import { Box, Grid, Typography } from '@mui/material';
import moment from 'moment';
import Title from '/@/components/title';
import settings from '/@/core/settings';
import { _ } from '/@/locale';
import styles from './styles.module.css';

const CreatedBy = ({ user, url }: { user: { email: string; first_name: string; last_name: string }; url?: string }) => {
    const isSettingsValid = url === settings.app.url.replace(/^https?:\/\//, '');
    return (
        <div className={`${styles.user} mp-mask`}>
            <Grid
                container
                justifyContent={'space-between'}
                alignItems={'center'}
                sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
            >
                <Grid item md={4}>
                    <Title>{_('Creado por')}</Title>
                </Grid>
                <Grid
                    item
                    container
                    justifyContent={'end'}
                    alignItems={'center'}
                    md={6}
                    sx={{ pb: { xs: 4, md: 0 } }}
                    flexWrap={'nowrap'}
                >
                    <Typography sx={{ pr: 1 }}>{_('Vía ')}</Typography>
                    {isSettingsValid && (
                        <Box sx={{ pr: 0.3 }}>
                            <img src={settings.app.favicon} style={{ height: 20 }} alt='favicon' />
                        </Box>
                    )}
                    <Typography>
                        <a href={url} target='_blank' rel='noreferrer' style={{ width: 'min-content' }}>
                            {url}
                        </a>
                    </Typography>
                </Grid>
            </Grid>
            <div className={styles.userInfo}>
                <div className={styles.label}>{_('Nombre')}</div>
                {user.first_name} {user.last_name}
                <div className={styles.label}>{_('Email')}</div>
                {user.email}
                <div className={styles.label}>{_('Fecha')}</div>
                {moment().format('LL')}
            </div>
        </div>
    );
};

export default CreatedBy;
